import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '@shared/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full px-0.5',
      'transition-[background-color,box-shadow,border-color] duration-normal ease-standard',
      'focus-visible:outline-none focus-visible:border focus-visible:border-[#A3A3A3]',
      'focus-visible:shadow-[0_0_0_3px_rgba(163,163,163,0.5)]',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-base-primary data-[state=unchecked]:bg-base-border',
      className,
    )}
    {...props}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block size-4 rounded-full bg-base-background shadow-lg ring-0',
        'transition-transform duration-normal ease-standard',
        'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
